import styled, { css } from 'styled-components'

import * as colors from '../../constants/colors'
import * as button from '../button'
import * as heading from '../heading'
import * as input from './input'
import * as select from './select'
import * as glyphs from '../../icons/glyphs'

export const TRANSITION = `0.3s ease`
export const BORDER_COLOR = colors.PRIMARY_SAND_200
export const BORDER = `1px solid ${BORDER_COLOR}`

const NavigationButtonBase = styled(button.UnstyledButton)`
  color: ${colors.PRIMARY_SAND_500};
  position: relative;
  top: -3px;
  transition: color ${TRANSITION};

  &:hover {
    color: ${colors.PRIMARY_BLUE_500};
  }
`

export const PrevButton = styled(NavigationButtonBase)`
  transform: rotate(90deg);
  margin-left: 10px;
`

export const NextButton = styled(NavigationButtonBase)`
  transform: rotate(-90deg);
  margin-right: 10px;
`

export const Header = styled.div`
  align-items: center;
  border-bottom: ${BORDER};
  display: flex;
  justify-content: center;
  padding: 12px 0;
  width: 100%;

  ${select.Wrapper} {
    align-items: center;
    position: relative;
    top: -3px;
  }

  ${select.Label} {
    ${heading._xSmallStyle}
  }
`

export const HeaderMiddle = styled.div`
  align-items: center;
  display: flex;
  height: 26px;
  justify-content: center;
  width: 100%;
`

export const Label = styled(heading.XS)`
  padding-bottom: 8px;
  padding-top: 2px;
`

export const CustomInput = styled(input.Input)<{ value?: any }>`
  padding-left: 0;
  width: 94px;

  ${({ value }) => {
    if (value) {
      return css`
        text-align: right;
      `
    }
  }}
`

export const InputWrapper = styled(input.ComposedWrapper)`
  box-sizing: border-box;
  height: 50px;
  position: relative;
  width: fit-content;

  &:focus-within::before {
    background-color: ${colors.PRIMARY_BLUE_500};
  }

  &&::before {
    ${({ $disabled }) => {
      if ($disabled) {
        return css`
          background-color: ${colors.PRIMARY_SAND_200};
        `
      }
    }}
  }

  ${input.Input} {
    order: 2;
  }

  ${glyphs.stroke.Calendar} {
    margin-top: 2px;
  }
`

export const DropdownWrapper = styled(input.ComposedWrapper)`
  align-items: center;
  display: flex;
  height: 50px;
  padding: 0 13px;
  width: fit-content;

  ${glyphs.Icon} {
    color: ${colors.PRIMARY_SAND_500};
  }
`
